import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import CreatedDate from './CreatedDate'
import classNames from 'classnames'
import ProductType from './ProductType'
import {Checkbox, Tag} from 'antd'
import convertDateOverTime from '../../../../helpers/convertDateOverTime'
import BatchNote from './BatchNote'

class BatchesRows extends Component {
    _generateLevel = (level) => {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return <Tag className={classNames(`tag-${level}`)}
                    color={color}>{level !== undefined ? level : 'medium'}</Tag>
    }

    _detectChecked = () => {
        const {item, selectedItems} = this.props
        return selectedItems.includes(item._id)
    }

    _handleChange = () => {
        const {item, updateSelectedOrders} = this.props
        const isChecked = this._detectChecked()

        updateSelectedOrders(item._id, !isChecked)
    }

    render() {
        const {item, onChangeProductType, handleChangeInput, newFilter} = this.props
        const {status, partner, sewing_partner, merge_file_status, brand, max_overtime, statistic, tags, note} = {...item}
        const {without_moved, total, moved, shipped, completed} = {...statistic}
        const {status : status_filter}  = {...newFilter}
        const quantity = (status_filter && status_filter === "completed_without_shipped") ? (total - moved - shipped) : (status_filter && status_filter === "completable") ? (total - moved - completed) : without_moved
        
        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
            'printing progress-bar-animated progress-bar-striped': status === 'printing',
            'printed': status === 'printed',
            'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
            'transferred': status === 'transferred',
            'confirmed': status === 'confirmed',
            'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
            'sewing': status === 'sewing',
            'completed': status === 'completed' || status === 'done',
        })

        const colorMerge = classNames({
            'pending progress-bar-animated progress-bar-striped': merge_file_status === 'created',
            'printing progress-bar-animated progress-bar-striped': merge_file_status === 'pending',
            'processing progress-bar-animated progress-bar-striped': merge_file_status === 'processing',
            'completed': merge_file_status === 'done',
            'error': merge_file_status === 'error',
            'cancel-ship': merge_file_status === 'retry',
        })

        const warningBatch = max_overtime >= -1
        const overtimed = !!warningBatch && max_overtime > 0
        const almostOvertime = !!warningBatch && max_overtime <= 0
        const wraningStyle = !!warningBatch ? {background:`rgb(${(!!almostOvertime && !overtimed ? "255, 208, 26, 0.3" : "223, 31, 31, 0.2")})`} : {}
        const overtimeText = !!max_overtime ? convertDateOverTime(max_overtime) : '-'

        const isGiftTag = Array.isArray(tags) && tags.includes('gift')
        const isSampleTag = Array.isArray(tags) && tags.includes('sample')
        const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
        const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
        const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
        const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')

        return (
            <tr key={item._id} style={wraningStyle}>
                <td className="nameLo">
                    <Link to={`/batches/${item._id}`} target="_blank">
                        {item.name}
                    </Link>
                    {
                        this._generateLevel(item.level)
                    }

                    {   
                        isGiftTag && <Tag color="#6c757d">Hàng tặng</Tag>
                    }

                    {
                        isSampleTag && <Tag color="#6c757d">Hàng mẫu</Tag>
                    }

                    {
                        isFbaTag && <Tag color="#6c757d">FBA</Tag>
                    }

                    {
                        isFastShipTag && <Tag color="#6c757d">Ship nhanh</Tag>
                    }

                    {
                        isUIDSAMPLETag && <Tag color="#6c757d">UIDSAMPLE</Tag>
                    }

                    {
                        isFastProductionTag && <Tag color="#FFA500">Sản xuất nhanh</Tag>
                    }

                    {
                        isTikTokTag && <Tag color="#dc3644">TIKTOK</Tag>
                    }

                    {
                       isCutOff && <Tag color="#FF6600">cutoff</Tag>
                    }

                    {
                        isCutOffNoel && <Tag color="#FF6600">cutoff_noel</Tag>
                    }

                    {
                        isCutOffNewYear && <Tag color="#FF6600">cutoff_new_year</Tag>
                    }
                </td>
                <CreatedDate field="created_at" item={item}/>
                <CreatedDate field="printed_at" item={item}/>
                <CreatedDate field="cut_at" item={item}/>
                <CreatedDate field="engraved_at" item={item}/>
                <CreatedDate field="improved_at" item={item}/>

                <ProductType 
                    types={item.product_types} 
                    brand={brand} 
                    onChangeProductType={onChangeProductType} 
                    handleChangeInput={handleChangeInput}
                />
                <td>{quantity || quantity === 0 ? quantity :'-'}</td>
                <td className='d-flex align-items-center'>
                    {max_overtime > 0 && 
                        <label 
                            className='btn btn-sm mr-1 mb-0' 
                            style={{
                                background: 'rgb(255 77 80)', 
                                color:'white',
                            }}
                        >
                            Quá hạn
                        </label>
                    }
                    <span className={`mb-0 ${max_overtime > 0 ? 'text-danger' : ''}`}>{overtimeText}</span>
                </td>
                <td className="text-center Status">
                    <span className={`badge ${status} badge-pill`}>{status}</span>
                </td>
                <td className="">{(partner !== undefined && partner !== null) ? partner.name : '-'}</td>
                {/* <td className="">{(sewing_partner !== undefined && sewing_partner !== null) ? sewing_partner.name : '-'}</td> */}
                {/* <td className="note">{note ? note : ''}</td> */}
                <BatchNote note={item.note}/>
            </tr>
        )
    }
}

BatchesRows.propTypes = {
    item: PropTypes.object.isRequired,
    onChangeProductType: PropTypes.func
}

export default BatchesRows
